import { render } from "./search.vue?vue&type=template&id=5fda7c8e"
import script from "./search.vue?vue&type=script&lang=js"
export * from "./search.vue?vue&type=script&lang=js"

import exportComponent from "D:\\wwwroot\\vant\\lan_v3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__